<template>
  <div id="idleHome" class="container">
    <div class="bg" style="margin-bottom:20px;">
      <div class="lv2Text t0">
        <span style="margin-right:30px">闲置换钱 快速出手</span>
        <span>
          <router-link to="/user/idlePublish">
            <el-button round size="small">发布闲置</el-button>
          </router-link>
        </span>
      </div>
    </div>
    <div class="bg" style="margin-bottom:20px">
      <el-row>
        <el-col :span="1">
          <div style="line-height:44px;font-size:13px;text-align:right" class="lv3Text">分类：</div>
        </el-col>
        <el-col :span="22">
          <div>
            <el-button
              type="text"
              size="mini"
              class="c"
              :class="activeId==1?'active':''"
              @click="select(1)"
            >全部</el-button>
            <el-button
              v-for="(item,index) of options"
              :key="index"
              type="text"
              size="mini"
              class="c"
              :class="activeId==(index+2)?'active':''"
              @click="select(index+2,item)"
            >{{item}}</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-row :gutter="40">
        <el-col :span="6" v-for="(item,index) of data" :key="index">
          <div class="box">
            <el-image
              class="cover"
              :src="serve + _.split(item.images, ';', 1)"
              fit="cover"
            ></el-image>
            <div class="t3">{{item.title}}</div>
            <el-row class="t3">
              <el-col :span="4">
                <div></div>
                <el-image class="pic" :src="item.headImg" fit="cover"></el-image>
              </el-col>
              <el-col :span="8">
                <div style="line-height:30px">{{item.nickname}}</div>
              </el-col>
              <el-col :span="12">
                <div
                  class="lv0Text"
                  align="right"
                  style="line-height:30px"
                >&yen;{{item.selling_price}}</div>
              </el-col>
            </el-row>
            <div class="btn">
              <el-button round size="medium" style="width:130px;" @click="go(item.id)">马上交换</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pager">
      <el-pagination
        background
        hide-on-single-page
        layout="prev, pager, next"
        :total="total"
        :current-page="currentPage"
        @current-change="pageChange"
        :page-size="20"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      //
      p: "",
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      page: 1,
      data: {},
      activeId: 1,
      total: 0,
      currentPage: 1,
      options: [
        "抗体",
        "种质资源",
        "文具类",
        "试剂",
        "办公设备",
        "耗材",
        "仪器",
        "书籍",
        "实验室办公/日品"
      ]
    };
  },
  created() {
    //
    this.$store.state.user_location = "闲置交换";
    this.$store.state.leftMenuIndex = 14;
    this.initData();
  },
  methods: {
    //
    go(id) {
      this.$router.push("/viewIdle?id=" + id);
    },
    pageChange(v) {
      this.page = v;
      this.load();
    },
    load() {
      var category = "";
      if (this.activeId == 1) {
        category = null;
      } else {
        category = this.p;
      }
      this.axios
        .get(this.serve + "/useless_exchange", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page: this.page,
            category: category
          }
        })
        .then(res => {
          this.data = res.data.data.results;
          this.total = res.data.data.total;
          this.currentPage = _.toInteger(res.data.data.page);
        });
    },
    select(i, p) {
      this.activeId = i;
      this.p = p;
      this.load();
    },
    initData() {
      this.axios.get(this.serve + "/useless_exchange").then(res => {
        this.data = res.data.data.results;
        this.total = res.data.data.total;
        this.currentPage = _.toInteger(res.data.data.page);
      });
    }
  }
};
</script>
<style lang="scss">
#idleHome {
  padding-top: 20px;
  .t0 {
    text-align: center;
    font-size: 20px;
    padding: 20px 0;
  }
  .pager {
    background-color: transparent;
    text-align: center;
  }
  .btn {
    border-top: 1px solid #ddd;
    padding: 10px 0;
    text-align: center;
  }
  .cover {
    height: 268px;
    width: 268px;
    background-position: center;
    background-size: 100% auto;
  }
  .pic {
    height: 30px;
    width: 30px;
    background-position: center;
    background-size: 100% auto;
    border-radius: 50%;
    overflow: hidden;
  }
  .t3 {
    padding: 10px 20px;
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    margin-bottom: 20px;
  }
  .bg {
    background-color: #fff;
    border: 1px solid #ddd;
    .t1 {
      font-size: 25px;
      margin: 30px 0;
    }
    .t2 {
      margin: 20px 0;
    }
    .go {
      transition: 0.3s;
    }
    .go:hover {
      background-color: #ddd;
    }
    .c {
      padding: 3px 10px;
      margin: 12px 5px;
    }
    .c.active {
      background-color: #e2211c;
      color: #fff;
    }
  }
}
</style>